import { Injectable } from '@angular/core';
import { first, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { PITEventService } from '@pit/core';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreFacade } from '@pit/core-store';
import { IDtoShipmentReturnCode } from '@pit/frontend-model';
import { DtoShipmentReturnCodeStoreFactory } from './dto.shipment.return.code.store.factory';

@Injectable({
    providedIn: 'root'
})
export class DtoShipmentReturnCodeStoreFacade extends EntityStoreFacade<IDtoShipmentReturnCode> {

    constructor(store: Store<IDtoShipmentReturnCode>, dataServiceAccessor: EntityDataServiceAccessorService, eventService: PITEventService) {
        super(DtoShipmentReturnCodeStoreFactory.instance, store, 'DtoShipmentReturnCode', dataServiceAccessor, eventService);
    }

    public getSipmentReturnCodeByCode$(code: string): Observable<IDtoShipmentReturnCode> {
        return this.store
            .select(this.entityStoreFactory.getSelector('get.by.code')(code));
    }

    public async getSipmentReturnCodeByCodeAsync(code: string): Promise<IDtoShipmentReturnCode> {
        let result: IDtoShipmentReturnCode = null;

        try {
            result = (await this.getSipmentReturnCodeByCode$(code).pipe(first()).toPromise());
        } catch (error) {
            this.eventService.useMethod('error.log', error);
        }

        return result;
    }

}
